import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="max-w-[1280px] mx-auto md:p-6 p-4 leading-8 mt-5 md:mt-10 font-poppins text-slate-600">
      {/* Hero Title Section */}
      <div className="relative p-8 mb-8 overflow-hidden text-center border border-[#0B5647]/10 bg-gradient-to-br from-[#0B5647]/5 via-white to-slate-100 rounded-3xl shadow-sm select-none">
        <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-[#00261E] via-[#0B5647] to-[#00261E]"></div>
        <div className="relative z-10">
          <h1 className="text-3xl md:text-5xl font-black text-primary tracking-tight">
            TERMS & CONDITIONS
          </h1>
        </div>
      </div>

      {/* Section 1 */}
      <div className="relative bg-white border border-slate-200/60 rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow mb-6">
        <div className="relative pl-4 border-l-4 border-[#0c9e82] mb-5 select-none">
          <h2 className="text-lg md:text-xl font-bold text-primary">
            Section 1: Summary
          </h2>
        </div>
        <div>
          <p className="mb-4 text-xs md:text-sm leading-relaxed">
            1.1 It is essential that you read and understand these terms, as they apply to all bookings made through our Website for services provided by Parking Providers. They outline how to make, amend, or cancel bookings. By making a booking on our Website, you agree to be bound by these terms.
          </p>

          <p className="mb-4 text-xs md:text-sm leading-relaxed">
            1.2 When you purchase parking services via our Website or over the phone, you are also subject to the terms and conditions of the Parking Provider (referred to as "Parking Provider Terms"). It is your responsibility to read and understand the relevant Parking Provider Terms for the parking service you are booking.
          </p>

          <div className="pl-4 border-l border-slate-200 ml-2 mb-4 space-y-4">
            <p className="text-xs md:text-sm leading-relaxed">
              1.2.1 We act solely as a booking agent for Parking Providers. We do not provide or operate the parking services directly. By booking through our Website, you acknowledge and agree that we are not responsible for the supply or delivery of these services. This responsibility lies with the Parking Provider.
            </p>

            <p className="text-xs md:text-sm leading-relaxed">
              1.2.2 Any claims related to the supply or delivery of parking services should be directed to the Parking Provider, as these are subject to their terms and conditions.
            </p>

            <p className="text-xs md:text-sm leading-relaxed">
              1.2.3 Your booking is also subject to our Privacy Policy and Cookies Policy.
            </p>

            <p className="text-xs md:text-sm leading-relaxed">
              1.2.4 These terms may be updated at any time without prior notice. However, the terms applicable to your booking are those displayed on the Website at the time of your booking. We recommend reviewing these terms before making a booking to ensure you accept them.
            </p>
          </div>
        </div>
      </div>

      {/* Section 2 */}
      <div className="relative bg-white border border-slate-200/60 rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow mb-6">
        <div className="relative pl-4 border-l-4 border-[#0c9e82] mb-5 select-none">
          <h2 className="text-lg md:text-xl font-bold text-primary">
            Section 2: Definitions
          </h2>
        </div>
        <div>
          <p className="mb-4 text-xs md:text-sm leading-relaxed">
            2.1 The following definitions apply to these terms:
          </p>
          <div className="pl-4 border-l border-slate-200 ml-2 space-y-3.5">
            <p className="text-xs md:text-sm leading-relaxed">
              <strong>Booking Confirmation:</strong> The email confirmation sent by us or the Parking Provider after you complete a booking.
            </p>
            <p className="text-xs md:text-sm leading-relaxed">
              <strong>Parking Service:</strong> The parking service offered for booking on our Website.
            </p>
            <p className="text-xs md:text-sm leading-relaxed">
              <strong>Parking Provider:</strong> The third-party company operating the parking service you are booking through the Website.
            </p>
            <p className="text-xs md:text-sm leading-relaxed">
              <strong>Parking Provider Terms:</strong> The terms and conditions of the Parking Provider that apply to the parking service you book.
            </p>
            <p className="text-xs md:text-sm leading-relaxed">
              <strong>Website:</strong> The website you are using to make your booking.
            </p>
          </div>
        </div>
      </div>

      {/* Section 3 */}
      <div className="relative bg-white border border-slate-200/60 rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow mb-6">
        <div className="relative pl-4 border-l-4 border-[#0c9e82] mb-5 select-none">
          <h2 className="text-lg md:text-xl font-bold text-primary">
            Section 3: Who We Are and What We Do
          </h2>
        </div>
        <div className="space-y-4">
          <p className="text-xs md:text-sm leading-relaxed">
            3.1 We are TEKONO LIMITED, a company registered in London, United Kingdom (company number: 15780867). Our registered office address is 2nd Floor College House, 17 King Edwards Road Ruislip, London, United Kingdom, HA4 7AE
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            We facilitate bookings for parking services provided by third-party Parking Providers. However, we do not own, operate, or supply the parking services listed on our Website.
          </p>
        </div>
      </div>

      {/* Section 4 */}
      <div className="relative bg-white border border-slate-200/60 rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow mb-6">
        <div className="relative pl-4 border-l-4 border-[#0c9e82] mb-5 select-none">
          <h2 className="text-lg md:text-xl font-bold text-primary">
            Section 4: Our Liability
          </h2>
        </div>
        <div>
          <p className="mb-4 text-xs md:text-sm leading-relaxed">
            4.1 We act solely as a booking agent for Parking Providers whose services are booked through our Website. Therefore, you acknowledge and agree that:
          </p>
          <div className="pl-4 border-l border-slate-200 ml-2 mb-4 space-y-4">
            <p className="text-xs md:text-sm leading-relaxed">
              4.1.1 We are not responsible for providing or fulfilling the parking services (see paragraph 5.2.2 below). We are also not liable if the parking services you book do not meet your expectations or are unsuitable for your needs.
            </p>
            <p className="text-xs md:text-sm leading-relaxed">
              4.1.2 Our liability is limited to direct losses resulting from our negligence in processing your booking, subject to paragraph 4.3 below.
            </p>
          </div>

          <p className="mb-4 text-xs md:text-sm leading-relaxed">
            4.2 We do not accept responsibility or liability for any loss or damage arising from:
          </p>
          <div className="pl-4 border-l border-slate-200 ml-2 mb-4 space-y-4">
            <p className="text-xs md:text-sm leading-relaxed">
              4.2.1 Incorrect, incomplete, or misleading information you provide on the Website, such as an inaccurate email address or contact number
            </p>
            <p className="text-xs md:text-sm leading-relaxed">
              4.2.2 The accuracy or content of reviews displayed on the Website related to parking services
            </p>
            <p className="text-xs md:text-sm leading-relaxed">
              4.2.3 Acts, omissions, errors, or defaults of Parking Providers or any third parties responsible for delivering the parking services booked through the Website.
            </p>
            <p className="text-xs md:text-sm leading-relaxed">
              4.2.4 Costs incurred in purchasing replacement services due to errors or omissions by a Parking Provider or third party.
            </p>
            <p className="text-xs md:text-sm leading-relaxed">
              4.2.5 Losses not foreseeable by you and us at the time of booking
            </p>
            <p className="text-xs md:text-sm leading-relaxed">
              4.2.6 Losses related to the use of parking services for trade, business, craft, or professional purposes, including loss of profit, revenue, data, or earnings
            </p>
          </div>

          <p className="mb-4 text-xs md:text-sm leading-relaxed">
            4.3 You are responsible for ensuring you allow sufficient time to use the parking service you have booked.
          </p>
          <p className="mb-4 text-xs md:text-sm leading-relaxed">
            4.4 Nothing in these terms excludes or limits our liability for death or personal injury caused by our negligence, fraud, or any liability that cannot be excluded under applicable law.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            4.5 Our total liability for claims arising from the use of the Website is limited to the total cost of your booking, including any booking fees paid to us.
          </p>
        </div>
      </div>

      {/* Section 5 */}
      <div className="relative bg-white border border-slate-200/60 rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow mb-6">
        <div className="relative pl-4 border-l-4 border-[#0c9e82] mb-5 select-none">
          <h2 className="text-lg md:text-xl font-bold text-primary">
            Section 5: Parking Services and Parking Providers
          </h2>
        </div>
        <div>
          <p className="mb-4 text-xs md:text-sm leading-relaxed">
            5.1 Our Website facilitates bookings for parking services provided by third-party Parking Providers
          </p>
          <p className="mb-4 text-xs md:text-sm leading-relaxed">
            5.2 When you book a parking service via the Website, you agree that:
          </p>
          <div className="pl-4 border-l border-slate-200 ml-2 space-y-4">
            <p className="text-xs md:text-sm leading-relaxed">
              5.2.1 Your booking creates a contract between you and the Parking Provider, subject to the relevant Parking Provider Terms.
            </p>
            <p className="text-xs md:text-sm leading-relaxed">
              5.2.2 The Parking Provider Terms govern the provision of the parking services and are separate from these terms, which govern the booking process.
            </p>
            <p className="text-xs md:text-sm leading-relaxed">
              5.2.3 You have read and understood the relevant Parking Provider Terms for the service you have booked
            </p>
            <p className="text-xs md:text-sm leading-relaxed">
              5.2.4 Claims related to the delivery of parking services must be directed to the Parking Provider, as their terms govern the supply and performance of these services.
            </p>
          </div>
        </div>
      </div>

      {/* Section 6 */}
      <div className="relative bg-white border border-slate-200/60 rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow mb-6">
        <div className="relative pl-4 border-l-4 border-[#0c9e82] mb-5 select-none">
          <h2 className="text-lg md:text-xl font-bold text-primary">
            Section 6: Making Bookings
          </h2>
        </div>
        <div className="space-y-4">
          <p className="text-xs md:text-sm leading-relaxed">
            6.1 A booking is confirmed once you receive a booking reference via a Booking Confirmation. Retain this confirmation as it contains details on amending or canceling your booking (see Section 7).
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            6.2 By completing a booking, you accept these terms and the Parking Provider Terms. We are not responsible for non-delivery of the Booking Confirmation due to incorrect contact details or email transmission issues.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            6.3 All parking services offered on the Website are subject to availability, and prices may change. We reserve the right to amend or discontinue services without notice
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            6.4 If a Parking Provider cannot fulfill your booking, we will notify you and arrange a refund to the original payment method. We are not liable for any other losses arising from the Parking Provider's inability to fulfill your booking
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            6.5 It is your responsibility to provide accurate contact information when booking and to verify the details in the Booking Confirmation match your requested service
          </p>
          <div>
            <p className="mb-4 text-xs md:text-sm leading-relaxed">
              6.6 Information you provide on the Website may be used by us or the Parking Provider
            </p>
            <div className="pl-4 border-l border-slate-200 ml-2 space-y-4">
              <p className="text-xs md:text-sm leading-relaxed">
                6.6.1 For details on how we use your information, refer to our Privacy Policy
              </p>
              <p className="text-xs md:text-sm leading-relaxed">
                6.6.2 For information on how the Parking Provider uses your data, consult their terms.
              </p>
            </div>
          </div>
          <p className="text-xs md:text-sm leading-relaxed">
            6.7 For clarity, we retain a portion of the sale price of parking services and pass the remainder to the Parking Provider, reflecting our role as a booking agent.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            6.8 Please ensure you have your booking confirmation voucher and/or booking reference with you when you travel. This will identify you as a Smart customer and enable the service provider to verify your booking.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            6.9 It's your responsibility to obtain chauffeur's telephone number and details of arrival procedure before departing for the airport - any missed bookings, flights or other problems arising from your failure to obtain this information will not be recompensed by Smart or any of our affiliates
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            6.10 Please ensure you have your booking confirmation voucher/and or booking reference with you when you travel. This will identify you as a smart/compare customer and enable the service provider to verify your booking.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            6.11 It's your responsibility to obtain chauffeur's telephone number and details of arrival procedure before departing for the airport - any missed bookings, flights or other problems arising from your failure to obtain this information will not be recompensed by smart/compare or any of our affiliates.
          </p>
        </div>
      </div>

      {/* Section 7 */}
      <div className="relative bg-white border border-slate-200/60 rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow mb-6">
        <div className="relative pl-4 border-l-4 border-[#0c9e82] mb-5 select-none">
          <h2 className="text-lg md:text-xl font-bold text-primary">
            Section 7: Prices
          </h2>
        </div>
        <div className="space-y-4">
          <p className="text-xs md:text-sm leading-relaxed">
            7.1 We strive to offer the best choice of parking services at competitive prices. Prices may vary seasonally and are subject to change without notice.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            7.2 Where applicable, bookings are subject to a non-refundable booking fee.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            7.3 Daily prices may vary based on the date and length of stay
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            7.4 Some parking services may include additional surcharges imposed by the Parking Provider, which are payable in addition to the advertised price.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            7.5 Special offers, vouchers, and promo codes cannot be combined unless explicitly stated.
          </p>
        </div>
      </div>

      {/* Section 8 */}
      <div className="relative bg-white border border-slate-200/60 rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow mb-6">
        <div className="relative pl-4 border-l-4 border-[#0c9e82] mb-5 select-none">
          <h2 className="text-lg md:text-xl font-bold text-primary">
            Section 8: Service Reviews Policy
          </h2>
        </div>
        <div className="space-y-4">
          <p className="text-xs md:text-sm leading-relaxed">
            8.1 All reviews related to parking services should be submitted directly on the Parking Provider's review platform. Customers may also receive an email from us inviting them to share feedback about their experience. Any reviews displayed on our Website are genuine and provided by customers who have used the parking services.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            8.2 Reviews about the parking services cannot be posted on our review platforms (e.g., Trustpilot, Google, etc.), as we are not the Parking Providers but only facilitate price comparison for car parks.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            8.3 Any reviews about parking services left on our review platforms will be disputed. If such reviews are not removed immediately upon our request, we reserve the right to take legal action. Additionally, any associated administrative or legal costs will be added to the claim.
          </p>
        </div>
      </div>

      {/* Section 9 */}
      <div className="relative bg-white border border-slate-200/60 rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow mb-6">
        <div className="relative pl-4 border-l-4 border-[#0c9e82] mb-5 select-none">
          <h2 className="text-lg md:text-xl font-bold text-primary">
            Section 9: Payment
          </h2>
        </div>
        <div className="space-y-4">
          <p className="text-xs md:text-sm leading-relaxed">
            9.1 Payment for parking services must be made online and in advance. Accepted payment methods are listed on our Website. We reserve the right to decline your booking if your card is declined for any reason or if the card has been used fraudulently or without the cardholder's permission.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            9.2 All prices are displayed in the currency of the selected country and include sales tax where applicable.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            9.3 If you make a booking using a non-UK credit or debit card, your account will be charged based on your card issuer's exchange rate on the transaction date, and you may incur additional conversion fees.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            9.4 VAT receipts can only be provided where the Parking Provider has agreed to allow us to do so and has supplied us with the necessary VAT details. If we do not have this information, we will be unable to issue a VAT receipt.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            9.5 If you request a VAT receipt and we lack the Parking Provider's consent or details, we will contact the Parking Provider to obtain the required information. Once received, we will process your request
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            9.6 Please note, we cannot guarantee that the Parking Provider will agree to provide the necessary details. If you require a VAT receipt urgently, we recommend contacting the Parking Provider directly.
          </p>
        </div>
      </div>

      {/* Section 10 */}
      <div className="relative bg-white border border-slate-200/60 rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow mb-6">
        <div className="relative pl-4 border-l-4 border-[#0c9e82] mb-5 select-none">
          <h2 className="text-lg md:text-xl font-bold text-primary">
            Section 10: Amending Your Booking
          </h2>
        </div>
        <div className="space-y-4">
          <p className="text-xs md:text-sm leading-relaxed">
            10.1 If your booking is marked as "NON-FLEX," otherwise designated as unamendable, it cannot be changed. This is due to the conditions set by the Parking Provider
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            10.2 You cannot change the date of your parking booking. In some cases, we may be able to amend the booking without requiring a cancellation, but this is subject to the conditions set by the Parking Provider. If an amendment isn't possible, you will need to cancel the existing booking and create a new one. The cancellation policy outlined below will apply.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            10.3 Unless stated otherwise, amendments can only be made to details such as flight numbers, passenger information, or vehicle details
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            10.4 You can also advise the Product Provider of any changes to your return dates/times on your arrival.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            10.5 If you have booked a parking provider that allows amendments, you may modify your booking only by providing at least 72 hours' notice before the scheduled usage date. If you have purchased Cancellation Cover, you may amend your booking with a minimum of 24 hours' notice prior to the booked date.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            10.6 Please note that amendment requests can only be processed during our office hours (Monday to Friday, 9:00 AM - 5:00 PM GMT) and are subject to the notice period specified above. If you submit a request outside of office hours, it will only be considered once office hours resume. If the request falls outside the required notice period for the parking provider, it will not be accepted.
          </p>
          <div>
            <p className="mb-4 text-xs md:text-sm leading-relaxed">
              10.7 To request an amendment to your booking, please contact us through one of the following methods:
            </p>
            <div className="pl-4 border-l border-slate-200 ml-2 space-y-4">
              <p className="text-xs md:text-sm leading-relaxed">
                10.7.1 Send a request via the Members Area, available here.
              </p>
              <p className="text-xs md:text-sm leading-relaxed">
                10.7.2 Email us at info@dummy.co.uk
              </p>
              <p className="text-xs md:text-sm leading-relaxed">
                10.7.3 Use the contact form available here
              </p>
              <p className="text-xs md:text-sm leading-relaxed">
                10.7.4 Reach us via the live chat function on our website
              </p>
            </div>
          </div>
          <p className="text-xs md:text-sm leading-relaxed">
            10.8 Ensure you provide the email used for booking, your booking reference, and details of the requested amendment when contacting us.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            10.9 Emails will be responded to within 72 business hours. For bookings within the next 72 hours, please use our live chat during office hours.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            10.10 Once an amendment request is received, we will contact the Parking Provider. Fulfillment is subject to availability and may incur additional charges.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            10.11 Amendments are only confirmed once you receive a confirmation email from us or the Parking Provider. If the request cannot be fulfilled, you may need to cancel and rebook, subject to the cancellation policy.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            10.12 Amendments are agreements between you and the Parking Provider. We are not liable if your requested amendment is declined
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            10.13 Any amendments related to extended bookings or date changes will incur a £10 charge, in addition to any difference in the price quote
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            10.14 Any amendments related to vehicle or personal details will incur a £15 charge.
          </p>
        </div>
      </div>

      {/* Section 11 */}
      <div className="relative bg-white border border-slate-200/60 rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow mb-6">
        <div className="relative pl-4 border-l-4 border-[#0c9e82] mb-5 select-none">
          <h2 className="text-lg md:text-xl font-bold text-primary">
            Section 11: Cancelling Your Booking
          </h2>
        </div>
        <div className="space-y-4">
          <p className="text-xs md:text-sm leading-relaxed">
            11.1 Regulation 28(1)(h) of the Consumer Contracts (Information, Cancellation, and Additional Charges) Regulations 2013 exempts leisure services on specific dates from the 14-day "cooling-off" period. This applies to bookings made through our Website, and cancellations are subject to these terms
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            11.2 Bookings marked "NON-FLEX," or otherwise non-cancellable cannot be canceled due to Parking Provider conditions. Cancellation and refund rules specific to certain services are outlined in the product details and your Booking Confirmation
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            11.3 The SMS confirmation service is non-refundable. Ensure your mobile device is compatible before purchasing.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            11.4 Transaction fees charged by banks or payment providers are non-refundable.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            11.5 Failure to meet booking requirements may result in no refund for unused services.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            11.6 Any administrative fees paid for changes or amendments are non-refundable.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            11.7 Refunds are not available if the booking date has passed.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            11.8 Unless otherwise stated, no refunds are available for unused or partially used services.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            11.9 Cancellable bookings require at least 72 hours' notice before the booking date. If Cancellation Cover is purchased, notice must be given at least 24 hours before the booking date.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            11.10 Cancellation Cover does not apply to same-day bookings or specific products where indicated.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            11.11 Cancellation requests can only be processed during our office hours (Monday to Friday, 9:00 AM - 5:00 PM GMT). Late requests will not be accepted.
          </p>
          <div>
            <p className="mb-4 text-xs md:text-sm leading-relaxed">
              11.12 To cancel your booking, contact us via:
            </p>
            <div className="pl-4 border-l border-slate-200 ml-2 space-y-3">
              <p className="text-xs md:text-sm leading-relaxed">
                Email at info@dummy.co.uk
              </p>
              <p className="text-xs md:text-sm leading-relaxed">
                The contact form here
              </p>
              <p className="text-xs md:text-sm leading-relaxed">
                Live chat on our Website.
              </p>
            </div>
          </div>
          <p className="text-xs md:text-sm leading-relaxed">
            11.13 For bookings within 7 days, please use the specified contact options above.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            11.14 Provide your booking reference and the email used during booking when requesting a cancellation.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            11.15 Cancellation requests must be submitted directly to us. Requests made to the Parking Provider are not valid.
          </p>
          <div className="pl-4 border-l border-slate-200 ml-2 space-y-4">
            <p className="text-xs md:text-sm leading-relaxed">
              11.16.1 If Cancellation Cover is purchased, a full refund (minus £20.00 cancellation fees) will be processed within 7–10 working days.
            </p>
            <p className="text-xs md:text-sm leading-relaxed">
              11.16.2 Without Cancellation Cover, a full refund (minus £20.00 cancellation fees) will be processed within 7–10 working days
            </p>
          </div>
        </div>
      </div>

      {/* Section 12 */}
      <div className="relative bg-white border border-slate-200/60 rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow mb-6">
        <div className="relative pl-4 border-l-4 border-[#0c9e82] mb-5 select-none">
          <h2 className="text-lg md:text-xl font-bold text-primary uppercase">
            Section 12: HOW CAN I COMPLAIN ABOUT MY BOOKING?
          </h2>
        </div>
        <div className="space-y-4">
          <p className="text-xs md:text-sm leading-relaxed">
            12.1 If you experience any issues with the Website, please notify us in writing by emailing info@dummy.co.uk
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            12.2 If you encounter any issues with the parking provider you booked through the Website before using their services, please contact us at info@dummy.co.uk We will guide you on the next steps
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            12.3 If you experience any issues with the parking provider during or after using their services, please contact them directly to give them the opportunity to resolve the issue. If possible, notify the parking provider about the issue before leaving their premises. Additionally, please inform us that you've encountered a problem and contacted the parking provider by emailing info@dummy.co.uk
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            12.4 If you do not receive a satisfactory response from the parking provider within 7 days of using their services, please reach out to us at info@dummy.co.uk If we do not hear from you within 14 days after your use of the parking provider, we may assume the issue has been resolved appropriately by the provider
          </p>
        </div>
      </div>

      {/* Section 13 */}
      <div className="relative bg-white border border-slate-200/60 rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow mb-6">
        <div className="relative pl-4 border-l-4 border-[#0c9e82] mb-5 select-none">
          <h2 className="text-lg md:text-xl font-bold text-primary uppercase">
            Section 13: GENERAL
          </h2>
        </div>
        <div className="space-y-4">
          <p className="text-xs md:text-sm leading-relaxed">
            13.1 If you do not receive a satisfactory response from the parking provider within 7 days of using their services, please reach out to us at info@dummy.co.uk If we do not hear from you within 14 days after your use of the parking provider, we may assume the issue has been resolved appropriately by the provider
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            13.2 These terms, along with our privacy policy and cookies policy, form the entire agreement between you and us regarding your use of our Website to make bookings for parking providers, and supersede any prior agreements.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            13.3 Any failure or delay by us in exercising any right under these terms will not waive that right, nor will any single or partial exercise of a right prevent further exercise of that right.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            13.4 Written notice includes notice sent by email.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            13.5 These terms, and your access to and use of the Website, will be governed by and construed in accordance with the laws of England.
          </p>
          <p className="text-xs md:text-sm leading-relaxed">
            13.6 You may bring claims against us in the English courts. If you reside in Wales, Scotland, or Northern Ireland, you may also bring claims against us in the courts of your country of residence. We may bring claims against you in the courts of your country of residence.
          </p>
        </div>
      </div>

    </div>
  );
};

export default TermsAndConditions;
